// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1Neu5","spinner-first":"Spinner_spinner-first__2jVw-","spinner-second":"Spinner_spinner-second__2qDkX","spinner-third":"Spinner_spinner-third__1jb-O"};